<template>
    <div class="rf-block">

        <div class="grid grid-cols-12 gap-4">
            <div class="xl:col-span-4 col-span-12">
                <span class="text-[0.875rem] font-semibold mb-0">Déstockage des matières premières (fiche technique) :</span>
                <p class="rf-help">Moment où les matières d'un plat vendu sortent du stock.</p>
            </div>
            <div class="xl:col-span-8 col-span-12">

                <p v-if="charge && !reglage.disponible" class="rf-info">
                    Le nouveau déstockage par fiche technique n'est pas encore mis en service pour cette société.
                    Les matières sont déstockées à l'envoi de la commande. Contactez votre administrateur pour l'activer.
                </p>

                <div class="form-check !ps-0">
                    <input class="form-check-input" type="radio" v-model="reglage.momentDestockage"
                           name="rfmomentdestockage" value="vente" id="rfmomentdestockage1" :disabled="!reglage.disponible">
                    <label class="form-check-label" for="rfmomentdestockage1">
                        1- À l'envoi de la commande
                    </label>
                </div>

                <div class="form-check !ps-0">
                    <input class="form-check-input" type="radio" v-model="reglage.momentDestockage"
                           name="rfmomentdestockage" value="cuisine" id="rfmomentdestockage2" :disabled="!reglage.disponible">
                    <label class="form-check-label" for="rfmomentdestockage2">
                        2- Quand la cuisine ou le bar commence la préparation (le bon quitte « Reçu »)
                    </label>
                </div>

                <p v-if="reglage.momentDestockage==='cuisine'" class="rf-help">
                    Un bon ramené à « Reçu » rend les matières au stock. À la comptabilisation de la facture, tout ce qui
                    n'a pas encore été déstocké l'est automatiquement (plats sans écran, bons oubliés). À la clôture de la
                    caisse, les factures non comptabilisées sont contrôlées de la même façon. Le changement s'applique aux
                    nouvelles factures.
                </p>

                <div class="rf-row">
                    <div class="custom-toggle-switch">
                        <input id="rfalertestock" v-model="reglage.alerteStock" type="checkbox" :disabled="!reglage.disponible">
                        <label for="rfalertestock" class="label-primary mb-1"></label>
                    </div>
                    <span class="rf-label">Afficher les matières premières en alerte de stock (sans bloquer la vente)</span>
                </div>

                <div class="rf-row">
                    <div class="custom-toggle-switch">
                        <input id="rfdoubleingredient" v-model="reglage.doubleIngredient" type="checkbox" :disabled="!reglage.disponible || !reglage.doubleDisponible">
                        <label for="rfdoubleingredient" class="label-primary mb-1"></label>
                    </div>
                    <span class="rf-label">Autoriser le double d'ingrédient à la caisse (sans supplément de prix)</span>
                </div>
                <p class="rf-help">
                    Désactivé : la caisse propose seulement de retirer un ingrédient. Les ingrédients concernés se cochent dans chaque fiche technique.
                </p>

                <!-- Enregistré par le bouton « Enregistrer les modifications » de l'onglet (tb.vue, saveSiModifie) -->
                <span v-if="reglage.regleLe" class="rf-date">Dernière modification : {{ reglage.regleLe }}</span>

            </div>
        </div>

    </div>
</template>

<script>
    import {randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "reglagefichetechnique",

        data() {
            return {
                loading:false,
                charge:false,
                initial:"",
                reglage:{
                    disponible:false,
                    actif:false,
                    momentDestockage:"vente",
                    alerteStock:true,
                    doubleIngredient:false,
                    doubleDisponible:false,
                    regleLe:"",
                },
            };
        },

        mounted(){
            this.load();
        },

        methods: {

            entetes(){
                return {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JwtService.getToken(),
                    'csrftoken': this.$store.state.appsociete
                };
            },

            url(action){
                return process.env.VUE_APP_API_URL+'/egl745874pstock771714dfe/fichetechnique/reglage/'+action+'/'+this.$store.state.appsociete+'/'+randomString();
            },

            async load(){

                const t = this;

                try {

                    let res=await axios.post(this.url('lire'),{},{headers: this.entetes() ,withCredentials: true});

                    if (res.data.success){
                        t.reglage=res.data.m;
                        t.initial=t.empreinte();
                        t.charge=true;
                    }

                }catch (error) {
                    /* bloc annexe de l'onglet : on reste sur les valeurs par défaut, non modifiables */
                }

            },

            empreinte(){
                return JSON.stringify([this.reglage.momentDestockage, !!this.reglage.alerteStock, !!this.reglage.doubleIngredient]);
            },

            /* Appelé par le bouton « Enregistrer les modifications » de l'onglet : n'envoie rien si rien n'a changé */
            async saveSiModifie(){

                if (!this.charge || !this.reglage.disponible || this.loading) { return; }
                if (this.empreinte()===this.initial) { return; }

                await this.save();

            },

            async save(){

                const t = this;
                this.loading=true;

                try {

                    let res=await axios.post(this.url('enregistrer'),{
                        momentDestockage:this.reglage.momentDestockage,
                        alerteStock:this.reglage.alerteStock,
                        doubleIngredient:this.reglage.doubleIngredient,
                    },{headers: this.entetes() ,withCredentials: true});

                    if (res.data.success){
                        t.reglage=res.data.m;
                        t.initial=t.empreinte();
                        toastr['success']( res.data.message,"<b></b>");
                    }else{
                        toastr['error']( res.data.message || "Enregistrement impossible.","<b></b>");
                    }

                }catch (error) {
                    toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.","<b>Erreur</b>")
                }

                this.loading=false;

            },

        },

    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.rf-block { margin-bottom:1.5rem; }
.rf-help { margin:4px 0 8px; font-size:0.76rem; color:var(--cf-muted); white-space:normal; }
.rf-info { margin:0 0 8px; padding:0.55rem 0.75rem; border-radius:var(--cf-radius-sm); background:rgb(var(--primary) / 0.06); color:var(--cf-ink); font-size:0.78rem; white-space:normal; }
.rf-row { display:flex; align-items:center; gap:0.6rem; margin:10px 0; }
.rf-label { font-size:0.82rem; color:var(--cf-ink); }
.rf-btn { margin-top:4px; }
.rf-date { margin-left:0.75rem; font-size:0.74rem; color:var(--cf-faint); }
</style>
